<div *ngIf="league" class="row">
  <div class="col-md-8 matches-nav">
    <div>
      <a class="mat-select-button" [class.selected]="upcomingSelected"
         routerLink="/spiele/kommende">Kommende Spiele</a>
      <a class="mat-select-button" [class.selected]="!upcomingSelected"
         routerLink="/spiele/vergangene">Vergangene Spiele</a>
    </div>
  </div>
  <div class="season-select">
    <mat-form-field *ngIf="league?.seasons" class="select-field" floatLabel="never">
      <mat-select disableOptionCentering required [formControl]="seasonFormControl">
        <mat-option *ngFor="let season of league.seasons" [value]="season._id"
                    (click)="onSeasonSelect(season)">
          {{ season.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div class="content-container">
  <lib-games-list *ngIf="games?.length > 0"
                  [live]="true"
                  [sortByRound]="true"
                  [showDate]="true"
                  [showStatus]="true"
                  [showReporterStatus]="true"
                  [openLinksInNewTab]="false"
                  [showAds]="true"
                  [hideShadow]="true"
                  [openLinksInNewTab]="false"
                  [events]="games"></lib-games-list>
  <button mat-raised-button class="load-more"
          *ngIf="games?.length < totalCount && !loading"
          (click)="loadMore()">
    Mehr Spiele laden
  </button>
  <span *ngIf="!loading && games?.length === 0" class="empty-games">
    Keine Spiele vorhanden
  </span>
</div>
<div class="spinner-container mt-3" *ngIf="loading">
  <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
</div>
